mobileSize =1150;
function countdownBanner() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('#siteInfoBannerWidget').appendTo('.swiper-container-outer');
  } else {
      $('#siteInfoBannerWidget').insertAfter('.header-logo');
  }
}

function countdownBannerInnerPage() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('body:not(.homepage) #siteInfoBannerWidget').appendTo('.header-bottom');
  } else {
      $('body:not(.homepage) #siteInfoBannerWidget').insertAfter('.header-logo');
  }
}

$(document).ready(function(){
  $(".footer-bottom .emailSignupText").html("GET UPDATES!");
  $(".footer-bottom .emailSubmitButton").html("SUBSCRIBE");
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1150) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1151) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
  countdownBanner();
  countdownBannerInnerPage();
  //Signup Input text Reappeare
	var emailInput = $('.footer-bottom .emailInputField input');
	emailInput.val('Enter email address');
	emailInput.on("click", function () {
		ClearDefaultText(this, 'Enter email address');
	});
	emailInput.on("blur", function () {
		if ($.trim($(this).val()) == '') {
			$(this).val('Enter email address');
		}
  });
  
  var searchInput = $('.header .searchBox input');
	searchInput.val('Search Website');
	searchInput.on("click", function() {
		ClearDefaultText(this, 'Search Website');
	});
	searchInput.on("blur", function() {
		if ($.trim($(this).val()) == '') {
			$(this).val('Search Website');
		}
	});
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
 
});

$(window).resize(function () {
  countdownBanner();
  countdownBannerInnerPage();
});